import React, { FC } from 'react';
import { ListItem } from '../../atoms/SortableListItem/SortableListItem';
import { SortableList } from '../../molecules';
//import styles from './LandscapeIndicatorsOrganism.module.css';

interface LandscapeIndicatorsOrganismProps {
  listItems: ListItem[];
  setListItems: (items: ListItem[], from: number, to: number) => void;
  changeOrderEnabled: boolean;
  setChangeOrderEnabled: (enabled: boolean) => void;
  handleDelete: (id: string) => void;
  handleEdit: (id: string) => void;
}

const LandscapeIndicatorsOrganism: FC<LandscapeIndicatorsOrganismProps> = ({
  listItems,
  setListItems,
  changeOrderEnabled,
  handleDelete,
  handleEdit,
}) => {
  return (
    <SortableList
      listItems={listItems}
      setListItems={setListItems}
      changeOrderEnabled={changeOrderEnabled}
      handleDelete={handleDelete}
      handleEdit={handleEdit}
    />
  );
};

export default LandscapeIndicatorsOrganism;
